import dayjs from "dayjs";
import axios from "../api/axios";
import { EQUIPMENT_COUNTERS_ENDPOINT, SETTLEMENTS_ENDPOINT } from "../consts";

interface CreateAndAssignSettlementCounterParams {
  settlementId: string | number;
  equipmentId: string | number;
  kind: string;
  value: string;
  // The ContractTermPrice this reading is meant to resolve, when known (see
  // findContractTermPriceId). When present, the new counter is pinned to
  // that settlement position via the counter-priority override mechanism.
  priceId?: string | number;
}

// Creates a new EquipmentCounter from a value the user manually typed in to
// resolve a settlement position that needs investigation (missing or
// outdated counter). This is a deliberate, explicit confirmation - the user
// is directly answering "what is the counter reading" - so it must be used
// for that position regardless of which provider is configured as the
// highest-priority one. Without pinning it, a manually entered reading
// could otherwise be silently ignored by the priority filter the exact same
// way an out-of-priority automated reading would be.
export const createAndAssignSettlementCounter = async ({
  settlementId,
  equipmentId,
  kind,
  value,
  priceId,
}: CreateAndAssignSettlementCounterParams): Promise<void> => {
  const response = await axios.post(EQUIPMENT_COUNTERS_ENDPOINT, {
    equipment_id: equipmentId,
    provider: "U",
    read_at: dayjs().format("YYYY-MM-DDTHH:mm:ssZ"),
    kind,
    value,
  });

  if (priceId != null) {
    await axios.post(`${SETTLEMENTS_ENDPOINT}${settlementId}/override-position-counter/`, {
      price_id: priceId,
      counter_id: response.data.id,
    });
  }
};
